import styled from "styled-components";

const DriverInfoSharedWrapper = styled.div`
  .driver-info-container {
    background: #f2f3f5;
    margin-bottom: 10px;
    padding: 24px;
    box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
    border-radius: 12px;
  }

  .driver-info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .driver-name-container {
    display: flex;
    flex-direction: column;

    .title {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 400;
      font-size: 0.8rem;
      color: #676f7c;
      align-self: flex-start;
    }

    .value {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 800;
      font-size: 1rem;
      color: #4c565c;
      align-self: flex-start;
    }

    @media screen and (max-width: 768px) {
      .value {
        font-size: 0.9rem;
      }
    }
  }

  .driver-id-container {
    display: flex;
    flex-direction: column;

    .title {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 400;
      font-size: 0.8rem;
      color: #676f7c;
      align-self: flex-start;
    }

    .value {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 800;
      font-size: 1rem;
      color: #4c565c;
      align-self: flex-start;
    }

    @media screen and (max-width: 768px) {
      .value {
        font-size: 0.9rem;
      }
    }
  }

  .driver-birth-year-container {
    display: flex;
    flex-direction: column;

    .title {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 400;
      font-size: 0.8rem;
      color: #676f7c;
      align-self: flex-start;
    }

    .value {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 800;
      font-size: 1rem;
      color: #4c565c;
      align-self: flex-start;
    }

    @media screen and (max-width: 768px) {
      .value {
        font-size: 0.9rem;
      }
    }
  }

  .driver-gender-container {
    display: flex;
    flex-direction: column;

    .title {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 400;
      font-size: 0.8rem;
      color: #676f7c;
      align-self: flex-start;
    }

    .value {
      font-family: "tawuniya";
      font-style: normal;
      font-weight: 800;
      font-size: 1rem;
      color: #4c565c;
      align-self: flex-start;
    }

    @media screen and (max-width: 768px) {
      .value {
        font-size: 0.9rem;
      }
    }
  }

  .driver-info-container-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .driver-info-container-right-edit {
    margin-left: 24px;
    margin-right: 4px;
    cursor: pointer;
  }

  .driver-info-container-right-delete {
    cursor: pointer;
  }

  .driver-info-container-missing-info > p {
    font-size: 0.9rem !important;
    color: #4c565c;
    display: flex;
    align-self: flex-start;
    @media screen and (max-width: 768px) {
      margin-top: 20px;
    }
  }

  .add-button-wrapper {
    margin: 24px 0;
  }

  .driver-form-wrapper {
    background: #F2F3F5;
    border-radius: 8px;
    margin: 24px 0;
    padding: 0 24px 24px 24px;
  }

  .driver-info-container-row-edit {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .driver-info-container-edit-dropdown {
    width: 100%;
    margin-right: 24px;
    border: none !important;

    .p-focus {
      box-shadow: none !important;
    }
  }

  .driver-info-container-edit-options {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 28px;
  }

  .driver-info-container-edit-options > span {
    cursor: pointer;
    color: #4c565c;
  }

  .driver-info-container-edit-options-save {
    background: #4c565c;
    border: none;
    margin-left: 28px;

    .img {
      margin-left: 10px;
    }
  }

  .button-primary {
    padding: 0px 16px 0px 24px;
    height: 50px;
    background: #6B47F5 !important;
    border-radius: 8px;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 16px;
    color: #ffffff;
  }

  .input-wrapper {
    background: #FFFFFF;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    padding: 0 17px;
    display: flex;
    flex-direction: row;
    margin: 0 10px;
    align-items: center;
    i {
      color: #6B47F5;
      width: 10%;
    }
    .input-control {
      color: #9AA2AF;
      border: none;
      width: 90%;
      &:focus {
        box-shadow: none !important;
      }
    }
  }

  @media screen and (max-width: 768px) {
  }
`;

export default DriverInfoSharedWrapper;
